/**
 * Points every ref at `node` and returns a React 19 ref cleanup. A callback
 * ref's own cleanup is kept; a callback ref without one is called with `null`,
 * and an object ref is reset, when the element goes away. Internal: not part of
 * the package's public exports.
 */
function assignRefs<T>(node: T, refs: Array<React.Ref<T> | undefined>) {
  const cleanups = refs.map((ref) => {
    if (typeof ref === 'function') {
      const cleanup = ref(node);
      return typeof cleanup === 'function' ? cleanup : () => ref(null);
    }
    if (ref) {
      (ref as React.RefObject<T | null>).current = node;
      return () => {
        (ref as React.RefObject<T | null>).current = null;
      };
    }
    return undefined;
  });
  return () => {
    for (const cleanup of cleanups) cleanup?.();
  };
}

export { assignRefs };
